<div class="inicio">


    <div class="columnas_layout_3">

        <div class="example-button-row">
            <button mat-mini-fab color="accent" matTooltip="Cancela esta asignación" (click)="clickCancelar($event)">
                <mat-icon style="transform: rotate(180deg);">forward icon</mat-icon></button>
        </div>

        <div class="columnas_layout">
            <div class="divTitulo">
                <mat-label class="titulo">
                    REMPLAZO DE EQUIPO PARA COMPUTADORA DE ESCRITORIO
                    <button mat-mini-fab color="primary" matTooltip="Click para más información"
                        (click)="clickMasInformacionR($event)"> <mat-icon>info</mat-icon> </button>
                </mat-label>
            </div>
        </div>

    </div>


    <br><br><br>


    <div class="columnas_2">

        <div class="celda">
            <mat-label class="negrita"> Equipo a remplazar <mat-label class="advertencia">*</mat-label></mat-label>
            <mat-form-field appearance="fill">
                <mat-select [formControl]="input__tabla_select" (selectionChange)="clickSelectTabla($event)">
                    <mat-option *ngFor="let select of opciones_select" [value]=select>{{ select }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="celda">
            <mat-form-field appearance="fill">
                <mat-label>Buscar</mat-label>
                <input matInput (keyup)="filtroDataDource($event)"
                    placeholder="Ingrese el nombre del dispositivo a buscar"
                    oninput="this.value = this.value.toUpperCase()">
            </mat-form-field>
        </div>

    </div>


    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <!-- Position Column -->
        <ng-container matColumnDef="OPCIONES">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> OPCIONES </th>
            <td mat-cell *matCellDef="let element">
                <button mat-mini-fab color="primary" (click)="clickSeleccionarEquipo(element)">
                    <mat-icon>check_circle</mat-icon> </button>
            </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="NOMBRE">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="NÚMERO DE SERIE">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> NÚMERO DE SERIE </th>
            <td mat-cell *matCellDef="let element"> {{element.serial}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="TIPO">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> TIPO </th>
            <td mat-cell *matCellDef="let element"> {{element.tipo}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="MODELO">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> MODELO </th>
            <td mat-cell *matCellDef="let element"> {{element.modelo}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="FABRICANTE">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> FABRICANTE </th>
            <td mat-cell *matCellDef="let element"> {{element.manufacturers_id}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="encabezados"></tr>
        <tr mat-row *matRowDef="let row; columns: encabezados;"></tr>

    </table>
    <mat-paginator #paginator class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]"
        showFirstLastButtons></mat-paginator>

</div>